document.addEventListener('DOMContentLoaded', function() {
	// 获取 cookie 的 language
	const get_cookie = () => {
		let decodedCookies = {};
		let cookieValue = document.cookie;
		if (cookieValue && cookieValue.length!== 0) {
			cookieValue.split(';').forEach(cookie => {
				let [key, value] = cookie.split('=').map(decodeURIComponent);
				decodedCookies[key.trim()] = value;
			});
		}
		return decodedCookies;
	};
			
	function customer_service() {
		let decodedCookies = get_cookie();
		let language = decodedCookies.language || "en";
		// 动态创建 script 元素
		const script = document.createElement('script');
		script.src = `//helps.live/webim/en-US/easemob.js?configId=5c8b614f-8d90-4060-88f1-673d508301d5&language=${language}`;
		script.defer = true;
		document.body.appendChild(script);
	}
				
	// 调用 customer_service 函数
	customer_service();
				
	// 隐藏环境客服按钮
	window.easemobim = window.easemobim || {};
	easemobim.config = {
		hide: true,
		autoConnect: true    
	};
});